<template>
	<h2>申込履歴</h2>
	<!-- 検索ボックス -->
	<!-- <div class="search_area hidden_box">
		<input type="checkbox" id="hidden" />
		<label for="hidden" class="hidden_label"><fa icon="chevron-down" class="icon" />&ensp;申込履歴を絞り込む</label>
		<div class="hidden_show">
			<dl>
				<dt><label for="m_jyokyo">申込状況</label></dt>
				<dd>
					<select id="m_jyokyo" v-model="jyotai">
						<option value="">---</option>
						<option value="0">未承認</option>
						<option value="1">承認済み</option>
						<option value="2">否認</option>
					</select>
				</dd>
				<dt>活動期間</dt>
				<dd><input type="date" class="date_period" v-model="kikan_from"> ～ <input type="date" class="date_period" v-model="kikan_to"></dd>
			</dl>
			<div class="flex justify-content_c">
				<button class="btn_off" @click="cleardata(1)">クリア</button>
				<button class="btn_on" @click="searchdata([jyotai,kikan_from,kikan_to],1)">この条件で検索する</button>
			</div>
		</div>
	</div> -->
	<!-- 一覧表示 -->
	<div class="table_scroll">
	<table class="list">
		<thead>
			<th width="8%">募集ID</th>
			<th width="20%">活動日</th>
			<!-- <th>承認</th> -->
			<th width="20%">施設名</th>
			<th width="40%">活動内容/変更内容</th>
			<th width="12%"></th>
		</thead>
		<tbody>
			<tr v-for="rireki in this.history" :key="rireki.katudo_date">
				<td data-label="募集ID">{{ rireki.id}}</td>
				<td data-label="活動日">{{ format(new Date(rireki.katudo_date),'yyyy/MM/dd(E)',{locale: ja}) }}<span v-if="(rireki.jyotai_code==='未処理' || (rireki.jyotai_code==='未承認'))" class="jotai_mi"><!--{{ rireki.jyotai_code }}-->確認中</span>
				<span v-if="rireki.jyotai_code==='承認済み'" class="jotai_sumi"><!--{{ rireki.jyotai_code }}-->ＯＫ</span>
				<span v-if="rireki.jyotai_code==='否認'" class="jotai_mi"><!--{{ rireki.jyotai_code }}-->確認中</span>
				</td>
				<!-- <td data-label="承認"> -->
				<!-- <span v-if="(rireki.jyotai_code==='未処理' || (rireki.jyotai_code==='未承認'))" class="jotai_mi">{{ rireki.jyotai_code }}</span>
				<span v-if="rireki.jyotai_code==='承認済み'" class="jotai_sumi">{{ rireki.jyotai_code }}</span>
				<span v-if="rireki.jyotai_code==='否認'" class="jotai_hinin">{{ rireki.jyotai_code }}</span> -->
				<!-- </td> -->
				<td data-label="施設名">{{ rireki.sisetu_name }}<br><fa icon="phone" class="icon" /><a :href="'tel:'+rireki.tel">{{rireki.tel}}</a></td>
				<td class="kaigyo" data-label="活動内容">{{ rireki.naiyou }}<span v-if="rireki.henkonaiyo" class="error"><br>{{ rireki.henkonaiyo }}</span></td>
				<td class="table-button"><button class="btn_off" @click="openModal(rireki.id)">詳細</button>

				</td>
			</tr>
		</tbody>
	</table>
				<!-- モーダルウィンドウ -->
				<transition name="modal2-fade">
					<modal2-window v-show="showContent" :item="postItem" :item2="postItem2" @close="closeModal" />
				</transition>
	</div>
</template>

<script>
import { inject } from 'vue';
// import { defineComponent, inject } from 'vue';
// import { ref } from 'vue';
import axios from 'axios';
// import common from '../static/common';
import Modal2Window from './ModalRireki.vue';
import { format } from 'date-fns'
import ja from 'date-fns/locale/ja'
// モーダル時背景固定
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

// export default defineComponent({
export default {
	name: "MypageMain",
	data() {
		return {
			history: Array,
			showContent: false,
			postItem: {},
			postItem2: {},
			// s_name: String,
			ID: Number,
		}
	},
	components: {
        Modal2Window,
	},
	watch: {
		$route(to, from) {
			if (to !== from) {
				// const targetElement = document.querySelector('#modalcont');
				const targetElement = document.querySelector('.scroll-detail');
				enableBodyScroll(targetElement);
			}
		}
	},
	methods: {
		openModal: async function(item) {
			let res = await axios.get('/api/bosyu_data/info?id=' + item)
			let res2 = await axios.get('/api/sisetu_data/info?id=' + res.data.sisetu_id)
			res.data.kikan_from = format(new Date(res.data.kikan_from),'yyyy/MM/dd(E)',{locale: ja})
			res.data.kikan_to = format(new Date(res.data.kikan_to),'yyyy/MM/dd(E)',{locale: ja})
			this.postItem = res.data
			this.postItem2 = res2.data
			this.showContent = true
			// const targetElement = document.querySelector('#modalcont');
			const targetElement = document.querySelector('.scroll-detail');
			disableBodyScroll(targetElement);
		},
		closeModal: function() {
			this.showContent = false
			// const targetElement = document.querySelector('#modalcont');
			const targetElement = document.querySelector('.scroll-detail');
			enableBodyScroll(targetElement);
		},
	},
	setup() {
		// 状態
		const { login } = inject('loginstate');

		// //API用の設定
		// const res = ref([]); //APIのレスポンス
		// const history = ref([]);  //表示する基データ
		// //検索キーワード
		// const kw_params = ref([]);
		// // const sisetu_name = ref('');
		// const jyotai = ref('');
		// const kikan_from = ref('');
		// const kikan_to = ref('');

		// let kw_jyotai = ref('');
		// let kw_kikan_from = ref('');
		// let kw_kikan_to = ref('');
		// kw_jyotai = '';
		// kw_kikan_from = '';
		// kw_kikan_to = '';

		// //一覧表示する基データを取得
		// async function getlistsdata(){
		// kw_params.value ={
		// 	id:login.id,
		// 	code:common.nvl(kw_jyotai,''),
		// 	kikan_from:common.nvl(String(kw_kikan_from).replace(/-/g,""),''),
		// 	kikan_to:common.nvl(String(kw_kikan_to).replace(/-/g,""),''),
		// }
		// res.value = await axios.get('/api/katudosya_data/history',{params:kw_params.value})
		// history.value = res.value.data
		// }
		// getlistsdata();

		// // 検索
		// // 検索ボタンイベント
		// async function searchdata(keywords){
		// 	console.log('search!')
		// 	kw_jyotai = common.nvl(keywords[0],'');
		// 	kw_kikan_from = common.nvl(keywords[1],'');
		// 	kw_kikan_to = common.nvl(keywords[2],'');
		// 	kw_params.value ={
		// 		id:login.id,
		// 		code:Number(kw_jyotai),
		// 		from:common.nvl(String(kw_kikan_from),'2000-04-01'),
		// 		to:common.nvl(String(kw_kikan_to),'2100-03-31'),
		// 		// from:common.nvl(String(kw_kikan_from).replace(/-/g,""),''),
		// 		// to:common.nvl(String(kw_kikan_to).replace(/-/g,""),''),
		// 	}
		// 	// getdata(kw_params.value)
		// 	// 検索文字列で絞り込み、検索文字列がない場合は全件取得
		// 	console.log(kw_params)
		// 	res.value = await axios.get('/api/katudosya_data/history',{params:kw_params.value})
		// 	// 配列にセット
		// 	history.value = res.value.data
		// 	console.log(history.value)
		// }

		// // クリア
		// async function cleardata(){
		// 	console.log('clear!')
		// 	//入力フォームの初期化
		// 	jyotai.value = '';
		// 	kikan_from.value = '';
		// 	kikan_to.value = '';
		// 	//変数の初期化
		// 	kw_jyotai = '';
		// 	kw_kikan_from = '';
		// 	kw_kikan_to = '';
		// 	kw_params.value ={
		// 		id:login.id,
		// 		code:common.nvl(kw_jyotai,''),
		// 		kikan_from:common.nvl(String(kw_kikan_from).replace(/-/g,""),''),
		// 		kikan_to:common.nvl(String(kw_kikan_to).replace(/-/g,""),''),
		// 	}
		// 	console.log(kw_params.value)
		// 	// 検索文字列で絞り込み、検索文字列がない場合は全件取得
		// 	res.value = await axios.get('/api/katudosya_data/history',{params:kw_params.value})
		// 	// 配列にセット
		// 	history.value = res.value.data
		// 	console.log(res.value.data)
		// 	// getdata(kw_params.value)
		// }

		// データ取得
		// async function getdata(kw_params){
		// 	// 検索文字列で絞り込み、検索文字列がない場合は全件取得
		// 	res.value = await axios.get('/api/katudosya_data/history',{params:kw_params})
		// 	// 配列にセット
		// 	history.value = res.value.data
		// }

		// データ取得（検索無し）
		// async function readData() {
		// 	const ID = Number(login.id);
		// 	let res = await axios.get('/api/katudosya_data/history?id=' + ID)
		// 	history.value = res.data
		// }
		// readData();

		return {
			login,
			// 日付の書式
			format,
			ja,
			// データ
			// history,
			// // 検索
			// jyotai,
			// kikan_from,
			// kikan_to,
			// searchdata,  // 抽出処理
			// cleardata,
			// // 共通関数
			// common,
		}

	},
	async created() {
		console.log('rireki')
		if(!this.login.id) {
			this.ID = Number(sessionStorage.getItem('id'))
		} else {
			this.ID = Number(this.login.id)
		}
		// console.log(ID)
		let res = await axios.get('/api/katudosya_data/history?id=' + this.ID)
		// console.log(res.data)
		this.history = res.data
	},
};
</script>


<style scoped>
.modal2-fade-enter-active,
.modal2-fade-leave-active {
	transition: opacity 0.3s;
}
.modal2-fade-enter-from,
.modal2-fade-leave-to {
	opacity: 0;
}
</style>